import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { HashRouter as Router, Route, Switch } from 'react-router-dom';

import store from './store';
import Logout from 'pages/logout';
import Index from 'pages';

import '@pwr/brandon-text';
import './scss/tachyons.css';
import './index.scss';
import 'font-awesome/css/font-awesome.css';
import '@pwr-ui/css/dist/modules/buttons.css';
import '@pwr-ui/css/dist/modules/forms.css';

function render() {
  ReactDOM.render(
    <Provider store={store}>
      <Router>
        <Switch>
          <Route exact path="/logout" component={Logout} />
          <Route component={Index} />
        </Switch>
      </Router>
    </Provider>,
    document.getElementById('root')
  );
}

function main() {
  global.version = process.env.VERSION;
  render();
}

main();



// WEBPACK FOOTER //
// ./src/index.js